import React from "react";
import ReactDOM from "react-dom";
import AcquireWebComponent from "../framework/MaterialUI";
import { map, orderBy, isEmpty } from "lodash";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Sector,
} from "recharts";
import { splitNumber } from "../../utils/utility";

import "./insights.css";

const renderActiveShape = props => {
  const {
    cx,
    cy,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
  } = props;
  return (
    <g>
      {/*
			<text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>{payload.name}</text>
			*/}
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 2}
        outerRadius={outerRadius + 10}
        fill={"#CCC"}
      />
    </g>
  );
};

const CustomizedTooltip = React.createClass({
  render() {
    const { stroke, name, value, fieldName } = this.props;
    return (
      <div
        className="recharts-default-tootip no-margin pt-5 pl-10 pr-10 pb-5"
        style={{ background: "#FFFCDC", border: "solid 1px #ccc" }}
      >
        <p className="recharts-tooltip-label no-margin"></p>
        <ul className="recharts-tooltip-item-list no-padding no-margin">
          <li
            className="recharts-tooltip-item"
            style={{
              display: "block",
              paddingTop: "4px",
              paddingBottom: "4px",
              stroke,
            }}
          >
            {name && (
              <span className="recharts-tooltip-item-name text-capital">
                <strong>{name}</strong>
              </span>
            )}
            {name && (
              <hr
                style={{
                  borderTop: "1px solid #000",
                  height: "1px",
                  display: "block",
                  margin: "5px 0",
                }}
              />
            )}
            <span
              className="recharts-tooltip-item-value "
              style={{ fontWeight: 300 }}
            >
              {fieldName} <strong>- {splitNumber(value)()}</strong>
            </span>
          </li>
        </ul>
      </div>
    );
  },
});

const styles = {
  textOverflow: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
};
class ListGraphicSection extends AcquireWebComponent {
  constructor(props) {
    super(props);
    this.state = { activeIndex: undefined };
  }

  onPieEnter(data, index) {
    this.setState({
      activeIndex: index,
      tooltip_name: data.payload.uniqueVisits ? data.payload.name : undefined,
      tooltip_field_name: data.payload.uniqueVisits
        ? "Unique Visit"
        : data.payload.name,
      tooltip_value: data.payload.uniqueVisits
        ? data.payload.uniqueVisits
        : data.payload.value,
      tooltip_stroke: data.payload.fill,
    });
    const tooltips = ReactDOM.findDOMNode(this).getElementsByClassName(
      "recharts-tooltip-wrapper",
    );
    if (tooltips && tooltips.length > 0) {
      const el = tooltips[0];
      el.style["visibility"] = "visible";
      el.style["padding-bottom"] = "0px";
    }
  }

  onPieLeave() {
    this.setState({
      activeIndex: -1,
    });
    const tooltips = ReactDOM.findDOMNode(this).getElementsByClassName(
      "recharts-tooltip-wrapper",
    );
    if (tooltips && tooltips.length > 0) {
      const el = tooltips[0];
      el.style["visibility"] = "hidden";
    }
  }

  renderBusinessFirmographic() {
    const { data } = this.props;
    const data1 = data.slice(0, 3);
    const data2 = data.slice(3);
    const style = {
        width: '50%',
        paddingRight: '20px',
        marginBottom: '-30px',
        paddingBottom: '20px'
      };
    return <div style={{
      display: 'flex',
    }}>
      <div style={style} className="light-grey-bottom-border">
        { data1.map(this.renderItem()) }
      </div>
      <div style={{ width: '50%', paddingLeft: '20px' }}>
        { data2.map(this.renderItem()) }
      </div>
    </div>;
  }

  renderItem = () => {
    const COLORS = ["#050505", "#1C4456", "#3888AB", "#87B7CD", "#AFCFDD"];
    const { fieldDisplayFunc, title, showGraphic, data } = this.props;
    const hideOverflowText = this.props.hideOverflow === true;
    const sortedData = orderBy(data, ["value"], ["desc"]);

    const wrapValue = val => {
      if (val === "N/A") {
        return "Unknown";
      }
      if (val === "0.00%") {
        return "Unknown";
      }
      return val;
    };
    let coloredData = {};
    if (showGraphic === true) {
      map(sortedData, function(data, index) {
        coloredData[data.name] = COLORS[index % COLORS.length];
      });
    }
   return (obj, idx) => {
    return (
        <div
          key={"list-" + idx}
          className="light-grey-top-border mt-15 pt-15"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div
            style={
              hideOverflowText
                ? {
                    width: "88%",
                    ...styles.textOverflow,
                    flexShrink: "0",
                    paddingRight: "20px",
                  }
                : { flexShrink: "0", paddingRight: "20px" }
            }
          >
            {!isEmpty(coloredData) && (
              <span
                className="insights-span-legend"
                style={{ background: coloredData[obj.name] }}
              >
                &nbsp;
              </span>
            )}
            <span>
              {obj.link ? <a href={obj.link}>{obj.name}</a> : obj.name}
            </span>
          </div>
          <div style={{ flexGrow: "1", position: "relative" }}>
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: 0,
                right: 0,
                transform: "translateY(-50%)",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textAlign: "right",
                textOverflow: "ellipsis",
                paddingRight:
                title === "Most Popular Pages" ? "20px" : 0,
              }}
            >
              {fieldDisplayFunc
                ? fieldDisplayFunc(obj.value)
                : wrapValue(obj.value)}
            </div>
          </div>
        </div>);
    }
  }

  render() {
    //		const COLORS = ['#050505', '#0E222C', '#1C4456', '#2A6581', '#3888AB', '#609FBD', '#609FBD', '#87B7CD', '#AFCFDD', '#D6E7EF'];
    const COLORS = ["#050505", "#1C4456", "#3888AB", "#87B7CD", "#AFCFDD"];
    const {
      title,
      data,
      footer,
      subTitle,
      showGraphic,
      subTitleStyle,
      mode,
    } = this.props;
    const sortedData = orderBy(data, ["value"], ["desc"]);
    // const hideOverflowText = this.props.hideOverflow === true;

    if (isEmpty(data)) {
      return (
        <div style={{ float: "left", width: "100%", position: "relative" }}>
          <div style={{ fontSize: "24px", fontWeight: "bold" }}>{title}</div>
          <div
            style={{
              width: "100%",
              minHeight: "200px",
              textAlign: "center",
              paddingTop: "60px",
              color: "#CDCDCD",
            }}
          >
            <div style={{ color: "#CDCDCD", fontSize: "24px", opacity: "0.8" }}>
              No Data
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ ...(mode === 'business' ? {} : {float: 'left'}), width: "100%", position: "relative" }}>
          <div
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              textTransform: "capitalize",
            }}
          >
            {title}
          </div>
          <div
            className={(mode === 'business' ? '' : "light-grey-bottom-border") + (footer ? '' : 'no-footer')}
            style={{
              width: showGraphic === true ? "50%" : "100%",
              position: "relative",
              paddingBottom: footer ? "15px" : '0',
              fontSize: "16px",
              ...(mode === 'business' ? {} : {
                marginBottom: footer ? "35px" : '0',
                float: 'left'
              }),
            }}
          >
            {subTitle && (
              <div
                className="text-right mt-10 mb-10"
                style={{
                  color: subTitle === "&nbsp;" ? "#FFF" : "inherit",
                  fontSize: "16px",
                  ...(subTitleStyle ? subTitleStyle : {}),
                }}
              >
                <strong>{subTitle}</strong>
              </div>
            )}
            {
              mode === 'business' ? this.renderBusinessFirmographic() :
              map(data, this.renderItem())}
          </div>
          <div
            style={{
              width: "50%",
              marginTop: "-10px",
              minHeight: "200px",
              display: showGraphic === true ? "block" : "none",
              position: "relative",
              ...(mode === 'business' ? {} : {float: 'left'})
            }}
          >
            <ResponsiveContainer width="100%" height="80%" minHeight={200}>
              <PieChart>
                <Pie
                  onMouseLeave={this.onPieLeave.bind(this)}
                  onMouseEnter={this.onPieEnter.bind(this)}
                  activeShape={renderActiveShape}
                  data={sortedData}
                  fill="#8884d8"
                  activeIndex={this.state.activeIndex}
                  dataKey="value"
                  innerRadius={40}
                  outerRadius={80}
                  isAnimationActive={false}
                >
                  {sortedData.map((entry, index) => (
                    <Cell
                      key={"insight-graphic-cell-" + index}
                      fill={COLORS[index % COLORS.length]}
                    />
                  ))}
                </Pie>
                <Tooltip
                  content={<CustomizedTooltip />}
                  name={this.state.tooltip_name}
                  value={this.state.tooltip_value}
                  stroke={this.state.stroke}
                  fieldName={this.state.tooltip_field_name}
                />
              </PieChart>
            </ResponsiveContainer>
          </div>
          { mode === 'business' ? null : [
          <br key="1" />,
          <br key="2" />
          ] }
          
          {sortedData.length === 5 && title === "DEMOGRAPHIC" && (
            <div className="mb-15">
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
            </div>
          )}
          {footer ? 
          <div className="mt-10 list-chart-footer" style={mode === 'business' ? {
            borderBottom: '1px solid #eeeff2',
            padding: footer ? '20px 0 15px' : '4px',
            marginBottom: '-20px'
          } : {}}>
            {footer}
          </div>
          : null }
        </div>
      );
    }
  }
}

ListGraphicSection.propTypes = {
  title: React.PropTypes.string.isRequired,
  subTitle: React.PropTypes.string,
  data: React.PropTypes.array,
  showGraphic: React.PropTypes.bool,
  fieldDisplayFunc: React.PropTypes.func,
  footer: React.PropTypes.element,
  mode: React.PropTypes.string,
};
export default ListGraphicSection;



// WEBPACK FOOTER //
// ./src/components/Insights/ListGraphic.jsx